import { render } from "./postCard.vue?vue&type=template&id=a62204fe&scoped=true"
import script from "./postCard.vue?vue&type=script&lang=js"
export * from "./postCard.vue?vue&type=script&lang=js"

import "./postCard.vue?vue&type=style&index=0&id=a62204fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a62204fe"]])

export default __exports__